import React from "react";

/*
 * Features component
 * props:
 * - anchor: string: defines the id of the section, usefull for menu links
 * - data: object: contains the data to be rendered
 */
export const Features = (props) => {
  return (
    <div id={props?.anchor} className="text-center">
      <div className="container">
        <div className="feature-row">
          <div className="section-title">
            <h2>{props.data?.title}</h2>
          </div>
        </div>
        <div className="feature-row ">
          {props.data
            ? props.data?.items.map((d, i) => (
                <div key={`${d.title}-${i}`} className="col-xs-3 col-md-3 feature-item"
                  style={{
                    backgroundColor: d.backgroundColor || 'white',
                    color: d?.textColor || 'black',
                    display: 'table'
                  }}
                >
                  {" "}
                  <div className="feature-image" style={{
                    minHeight: d.minHeight || '200px',
                  }}>
                    <img className="feature-image" src={d.img} alt={d.text}/>
                  </div>
                  <div className="feature-text">
                    <p style={{
                      fontSize: d.titleFontSize || '2em',
                      color: d.textColor || 'black',
                      backgroundColor: d.backgroundColor || 'white',
                    }}>
                      <b>{d.title}</b>
                    </p>
                    {
                      d.subTitle ? <p style={{
                        fontSize: d.subTitleFontSize || '1em',
                        color: d.textColor || 'black',
                        backgroundColor: d.backgroundColor || 'white',
                      }}>
                        {d.subTitle}
                      </p> : null
                    }
                    {
                      d.text ? <p style={{
                        fontSize: d.textFontSize || '1em',
                        color: d.textColor || 'black',
                        backgroundColor: d.backgroundColor || 'white',
                      }}>
                        {d.text}
                      </p> : null
                    }
                    {
                      d.readmore ? <a href={d.readmore}
                      className="btn btn-primary btn-block"
                      style={{
                        fontSize: d.readmoreFontSize || '1em',
                        color: d.textColor || 'black',
                        backgroundColor: d.backgroundColor || 'white',
                      }}>
                        {props.data?.read}
                      </a> : null
                    }
                  </div>
                </div>
              ))
            : "Loading..."}
        </div>
      </div>
    </div>
  );
};
